import styles from './PageProductIntroMobileSubcopy.module.css';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';

function PageProductIntroMobileSubcopy() {
  const { heroSubcopy: introSubcopy } = useSearchParamOrDefaultProps();
  return (
    <div className={styles.PageProductIntroMobileSubcopy}>{introSubcopy}</div>
  );
}

export default PageProductIntroMobileSubcopy;
